import { render, staticRenderFns } from "./downList.vue?vue&type=template&id=4b722b48&scoped=true&"
import script from "./downList.vue?vue&type=script&lang=js&"
export * from "./downList.vue?vue&type=script&lang=js&"
import style0 from "./downList.vue?vue&type=style&index=0&id=4b722b48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b722b48",
  null
  
)

export default component.exports